module.exports = __webpack_public_path__ + "img/lastestUser.1673fcfd.png";